<template>
  <div>
    <div class="row center-block">
      <div class="col-md-12">
        <div class="box">
          <!-- <div class="box-header">
          </div>         -->
          <div class="box-body">
            <full-calendar class='full-calendar' :options='calendarOptions'>
            </full-calendar>
          </div>
          <!-- <div class="box-footer">
          </div> -->
        </div>
      </div>
    </div>
  </div>  
</template>

<script>
import api from '../../api'
import SweetAlert from 'sweetalert2'
// https://fullcalendar.io/docs/vue
import FullCalendar from '@fullcalendar/vue'
import dayGridPlugin from '@fullcalendar/daygrid'
import interactionPlugin from '@fullcalendar/interaction'
import moment from 'moment'
import config from '../../config'
// import Event from 'event.js'

export default {
  name: 'WorkingCalendar',
  components: {
    FullCalendar // make the <FullCalendar> tag available
  },
  data() {
    return {
      DATE_FORMAT: config.dateFormat,
      DATE_FORMAT_ISO: config.dateFormatSql,
      listData: null,
      inquiryParam: {
        WhereClause: '',
        CurrentPageNumber: 1,
        PageSize: 9999,
        SortDirection: 'ASC',
        SortExpression: 'DayOff',
        WhereClauseByProject: ''
      },
      calendarOptions: {
        editable: true,
        selectable: true,
        selectMirror: true,
        dayMaxEvents: true,
        plugins: [
          dayGridPlugin,
          interactionPlugin // needed for dateClick
        ],
        initialView: 'dayGridMonth',
        events: [],
        dateClick: this.onDateClick,
        eventClick: this.onEventClick,
        eventDrop: this.onEventDrop,
        eventResize: this.onEventDrop,
        select: this.onDateSelect
      }
    }
  },
  computed: {
  },
  created() {
    this.inquiry()
  },
  mounted() {
    this.$root.$on('inquiryWorkingCalendarByProject', (projectIds) => {
      return this.inquiry()
    })
  },
  methods: {
    inquiry() {
      if (this.$store.state.userInfo.projects.length > 1) {
        SweetAlert.fire('Information', 'Please choose a project that you are authorized', 'info')
        return
      }

      let me = this
      let strDate = ''
      this.inquiryParam.WhereClauseByProject = 'ProjectId = ' + this.$store.state.userInfo.projects[0]
      api
        .request('Account', 'get', '/api/WorkingCalendar/Inquiry?WhereClause=' + this.inquiryParam.WhereClauseByProject + this.inquiryParam.WhereClause +
                                 '&PageSize=' + this.inquiryParam.PageSize + '&CurrentPageNumber=' + this.inquiryParam.CurrentPageNumber +
                                 '&SortDirection=' + this.inquiryParam.SortDirection + '&SortExpression=' + this.inquiryParam.SortExpression, null)
        .then(response => {
          me.calendarOptions.events = []

          var data = response.data
          data.entity.forEach(e => {
            strDate = moment(e.dayOff, this.DATE_FORMAT).format(this.DATE_FORMAT_ISO)
            me.calendarOptions.events.push({
              id: e.id,
              title: e.name,
              date: strDate,
              start: strDate,
              end: strDate,
              allDay: true
            })
          })
        })
        .catch(error => {
          var message = error.message
          SweetAlert.fire('Error', message, 'error')
        })
    },
    // onEvent(info, successCallback, failureCallback) {
    //   this.inquiryParam.WhereClause = 'ProjectId = ' + this.$store.state.userInfo.projects[0] +
    //                                   ' AND DayOff >= \'' + moment(info.start).format(this.DATE_FORMAT_ISO) + '\'' +
    //                                   ' AND DayOff <= \'' + moment(info.end).format(this.DATE_FORMAT_ISO) + '\''

    //   let me = this
    //   let strDate = ''
    //   api
    //     .request('Account', 'get', '/api/WorkingCalendar/Inquiry?WhereClause=' + this.inquiryParam.WhereClause +
    //                              '&PageSize=' + this.inquiryParam.PageSize + '&CurrentPageNumber=' + this.inquiryParam.CurrentPageNumber +
    //                              '&SortDirection=' + this.inquiryParam.SortDirection + '&SortExpression=' + this.inquiryParam.SortExpression, null)
    //     .then(response => {
    //       var data = response.data
    //       data.entity.forEach(e => {
    //         strDate = moment(e.dayOff, this.DATE_FORMAT).format(this.DATE_FORMAT_ISO)
    //         me.calendarOptions.events.push({
    //           id: e.id,
    //           title: e.name,
    //           date: strDate,
    //           start: strDate,
    //           end: strDate,
    //           allDay: true
    //         })
    //       })
    //     })
    //     .catch(error => {
    //       var message = error.message
    //       SweetAlert.fire('Error', message, 'error')
    //     })
    // },
    onDateSelect(selectInfo) {
      if (this.$store.state.userInfo.projects.length > 1) {
        SweetAlert.fire('Information', 'Please choose a project that you are authorized', 'info')
        return
      }

      let eventName = prompt('Please enter a new title for your event')
      if (eventName) {
        var me = this
        var reqData = {
          name: eventName,
          dayOff: moment(selectInfo.start).format(this.DATE_FORMAT),
          projectId: this.$store.state.userInfo.projects[0]
        }

        api
          .request('Account', 'post', '/api/WorkingCalendar/Create', reqData)
          .then(response => {
            if (response.data.returnStatus) {
              me.calendarOptions.events.push({
                id: response.data.entity.id,
                title: eventName,
                date: selectInfo.startStr,
                start: selectInfo.startStr,
                end: selectInfo.endStr,
                allDay: selectInfo.allDay
              })
            } else {
              SweetAlert.fire('Error', response.data.returnMessage, 'error')
            }
          })
          .catch(error => {
            var message = error.message
            SweetAlert.fire('Error', message, 'error')
          })
      }
    },
    onEventClick(clickInfo) {
      if (confirm(`Are you sure you want to delete the event '${clickInfo.event.title}'`)) {
        var me = this
        var reqData = {
          id: clickInfo.event.id,
          name: clickInfo.event.title,
          dayOff: moment(clickInfo.event.startStr, this.DATE_FORMAT_ISO).format(this.DATE_FORMAT),
          projectId: this.$store.state.userInfo.projects[0]
        }

        api
          .request('Account', 'post', '/api/WorkingCalendar/Delete', reqData)
          .then(response => {
            if (response.data.returnStatus) {
              clickInfo.event.remove()

              for (let i = 0; i < me.calendarOptions.events.length; i++) {
                const el = me.calendarOptions.events[i]
                if (el.id === parseInt(clickInfo.event.id)) {
                  me.calendarOptions.events.splice(i, 1)
                }
              }
            }
          })
          .catch(error => {
            var message = error.message
            SweetAlert.fire('Error', message, 'error')
          })
      }
    }
    // onDateClick: function(arg) {
    //   console.log(arg)
    //   alert('date click! ' + arg.dateStr)
    // },
    // handleEvents(events) {
    //   this.currentEvents = events
    // }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// WorkingCalendar.vue?a93ce3b4